export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 5a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V6a1 1 0 00-1-1H3zM0 6a3 3 0 013-3h18a3 3 0 013 3v12a3 3 0 01-3 3H3a3 3 0 01-3-3V6zm15.125 8.675c0 .365-.086.45-.45.45h-5.35c-.364 0-.45-.085-.45-.45V9.326c0-.365.086-.451.45-.451h5.35c.364 0 .45.086.45.451v5.349zM14.91 7H9.083A2.085 2.085 0 007 9.09v5.82C7 16.064 7.93 17 9.083 17h5.827A2.09 2.09 0 0017 14.91V9.09A2.09 2.09 0 0014.91 7zm-1.678 6.25H10.75v-2.46h2.482v2.46z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};